import { render, staticRenderFns } from "./FlexibleText.vue?vue&type=template&id=7ce924ac&scoped=true"
import script from "./FlexibleText.vue?vue&type=script&lang=ts"
export * from "./FlexibleText.vue?vue&type=script&lang=ts"
import style0 from "./FlexibleText.vue?vue&type=style&index=0&id=7ce924ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce924ac",
  null
  
)

export default component.exports